/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 10/3/13
 * Time: 10:26 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var DateUtility = require("utils/DateUtility");

    var GoogleAnalyticsConnectionModel = require("manager-components/google-analytics/models/GoogleAnalyticsConnectionModel");
    var GoogleAnalyticsProfileModel = require("manager-components/google-analytics/models/GoogleAnalyticsProfileModel");
    var GoogleAnalyticsProfileUrlModel = require("manager-components/google-analytics/models/GoogleAnalyticsProfileUrlModel");
    var GoogleAnalyticsProfilesCollection = require("manager-components/google-analytics/collections/GoogleAnalyticsProfilesCollection");
    var GoogleAnalyticsProfileUrlsCollection = require("manager-components/google-analytics/collections/GoogleAnalyticsProfileUrlsCollection");
    var GoogleAnalyticsProfileCampaignsCollection = require("manager-components/google-analytics/collections/GoogleAnalyticsProfileCampaignsCollection");
    var GoogleAnalyticsProfileCampaignKeywordsCollection = require("manager-components/google-analytics/collections/GoogleAnalyticsProfileCampaignKeywordsCollection");

    var Logger = require("logger");
    
    var ADSGoogleAnalyticsHelper = function() {

        /**
         *
         * @param success - callback(isConnected)
         * @param error - callback()
         */
        this.getConnectionStatus = function(success, error) {
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching connection status", "ADSGoogleAnalyticsHelper:getConnectionStatus");

            var connectionModel = new GoogleAnalyticsConnectionModel();

            connectionModel.fetch({
                success: function(model, response, options){
                    if(model.get("connected")) {
                        success(true);
                    }
                    else {
                        success(false);
                    }
                },
                error: function() {
                    error();
                }
            });
        };

        this.getProfiles = function(success, error){
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching profiles", "ADSGoogleAnalyticsHelper:getProfiles");

            var profilesCollection = new GoogleAnalyticsProfilesCollection();

            profilesCollection.fetch({
                success: function(collection, response, options) {
                    success(collection);
                },
                error: function() {
                    error();
                }
            });
        };

        // TODO: change profileModel to profileId
        this.getProfileUrls = function(profileModel, success, error){
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching profile's urls for profile id=" + profileModel.id, "ADSGoogleAnalyticsHelper:getProfileUrls");

            var profileUrlsCollection = new GoogleAnalyticsProfileUrlsCollection({
                profileId: profileModel.id
            });

            profileUrlsCollection.fetch({
                data: {
                    "start-date": _getStartDate(),
                    "end-date": _getEndDate()
                },
                success: function(collection, response, options) {
                    success(profileModel, collection);
                },
                error: function() {
                    error();
                }
            });
        };

        // TODO: change profileModel to profileId
        this.getProfileCampaigns = function(profileModel, success, error){
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching profile's campaigns for profile id=" + profileModel.id, "ADSGoogleAnalyticsHelper:getProfileCampaigns");

            var profileCampaignsCollection = new GoogleAnalyticsProfileCampaignsCollection({
                profileId: profileModel.id
            });

            profileCampaignsCollection.fetch({
                data: {
                    "start-date": _getStartDate(),
                    "end-date": _getEndDate()
                },
                success: function(collection, response, options) {
                    success(profileModel, collection);
                },
                error: function() {
                    error();
                }
            });
        };

        this.getProfileCampaignName = function(profileId, campaignId, success, error){
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching profile campaign name for profile id=" + profileId, "ADSGoogleAnalyticsHelper:getProfileCampaignName");

            var profileCampaignsCollection = new GoogleAnalyticsProfileCampaignsCollection({
                profileId: profileId
            });

            profileCampaignsCollection.fetch({
                data: {
                    "start-date": _getStartDate(),
                    "end-date": _getEndDate()
                },
                success: function(collection, response, options) {
                    var selectedCampaignModel = collection.get(campaignId);
                    if (selectedCampaignModel) {
                        success(selectedCampaignModel.get("name"));
                    } else {
                        error();
                    }
                },
                error: function() {
                    error();
                }
            });
        };

        // TODO: change profileModel to profileId, campaignModel to campaignId
        this.getProfileCampaignKeywords = function(profileModel, campaignModel, success, error){
            var logger = Logger.getLogger("AnalyticsDataSources");
            logger.debug("fetching campaign's keywords for profile id = " + profileModel.id + " campaign id=" + campaignModel.id,
                "ADSGoogleAnalyticsHelper:getProfileCampaignKeywords");

            var profileCampaignKeywordsCollection = new GoogleAnalyticsProfileCampaignKeywordsCollection({
                profileId: profileModel.id,
                campaignId: campaignModel.id
            });

            profileCampaignKeywordsCollection.fetch({
                data: {
                    "start-date": _getStartDate(),
                    "end-date": _getEndDate(),
                    "useStatisticModel": true
                },
                success: function(collection, response, options) {
                    success(profileModel, campaignModel, collection);
                },
                error: function() {
                    error();
                }
            });
        };

        // The start and end date are mandatory parameters when requesting profile's urls.
        // A product decision is to use start date of today minus a month and an end date of today
        function _getStartDate() {
            // Calculate by today's date minus 1 month
            var date = new Date();
            date.setMonth(date.getMonth() - 1); // yes, this actually works
            return DateUtility.date2StrYYYYMMdd(date);
        }

        function _getEndDate() {
            // Return today's date
            var date = new Date();
            return DateUtility.date2StrYYYYMMdd(date);
        }
    };

    return new ADSGoogleAnalyticsHelper();

});